import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sparkles, ArrowRight } from 'lucide-react';
import { IneaMark } from '@/components/IneaMark';

/**
 * Lot 1 (2026-09-03) — un membre Mars arrive sans diagnostic : l'entretien
 * Inéa est proposé et valorisé, jamais imposé (décision Laurent 02/09).
 * Remplace la tuile Diagnostic tant qu'il n'y a pas de diagnostic.
 */
export function InterviewInviteCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <button
      onClick={() => navigate('/onboarding')}
      className="card group relative h-full w-full overflow-hidden p-5 text-left"
    >
      <div
        className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full opacity-30 blur-2xl"
        style={{ background: 'radial-gradient(circle, #ec4899, transparent 70%)' }}
      />
      <div className="relative">
        <div className="mb-3 flex items-center justify-between">
          <span className="kicker text-pink">
            <Sparkles size={11} /> {t('interview.title')}
          </span>
          <ArrowRight
            size={15}
            className="text-ink/30 transition group-hover:translate-x-0.5 group-hover:text-pink"
          />
        </div>
        <div className="flex items-start gap-3">
          <IneaMark size={34} />
          <p className="text-[12.5px] leading-[1.5] text-ink/65">{t('interview.body')}</p>
        </div>
        <span className="mt-3 inline-flex items-center gap-1.5 text-[12.5px] font-700 text-pink">
          {t('interview.cta')} <ArrowRight size={13} />
        </span>
      </div>
    </button>
  );
}
